export default "/images/marker-sell.svg?c03c01bc83a0275bef5f2e1afd448803";